
      import List from './list.vue'
      import type { App, Plugin } from 'vue'

      export const ListPlugin: Plugin = {
        install(app: App) {
          app.component('List', List)
        },
      }
      export { List }
      